// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	version: "0.0.166",
	baseUrl: "https://dev-corehub.colibryx.com",
	projectName: "corehub",
	projectPrefix: "corehub",
	production: true,
	dev: true,
	canCreateTenants: false,
	signupEnabled: true,
	STORAGE_PREFIX: "corehub.",
	supabase: {
		url: "https://dev-api.corehub.colibryx.com",
		key: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzUwNDM0MjA3LCJleHAiOjE3ODE5NzAyMDd9.gAugQz_VMJkar656mrg0vnf_nVYWQsfP1XnHeli1Z9o",
		fileUrlPrefix:
			"https://dev-api.corehub.colibryx.com/storage/v1/object/public/",
		imageRenderPrefix:
			"https://dev-api.corehub.colibryx.com/storage/v1/render/image/public/",
		fileUrlResumablePrefix:
			"https://dev-api.corehub.colibryx.com/storage/v1/upload/resumable/",
	},
	fastify: {
		baseUrl: "http://localhost:11000",
		trpcUrl: "http://localhost:11000/trpc/",
		apiUrl: "http://localhost:11000/api/",
	},
	defaultTenant: "",
	mapboxApiKey:
		"pk.eyJ1IjoiY29saWJyeXgiLCJhIjoiY201dmFzcnZvMDU5cTJpc2V2ZWFob29ldyJ9.VCFaJzbEvTRsF5sx6HoeWg",
	tinymceApiKey: "",
	emailRedirectUrl: "https://dev-corehub.colibryx.com",
	googleApiKey: "AIzaSyCUVtwJjN1XlK7HTDeVEue9DrJXyHI2EBQ",
	facebook: {
		appId: "949179747255578",
		configId: "534697479428922",
		apiVersion: "v20.0",
	},
	invoice: {
		countryId: "IT",
		codeid: "04901390239",
		phone: undefined,
		email: undefined,
	},
};

// LOCALE
// export const environment = {
// 	baseUrl: "http://localhost:4200",
// 	projectName: "Serta",
// 	projectPrefix: "serta",
// 	production: false,
// 	canCreateTenants: false,
// 	signupEnabled: true,
// 	STORAGE_PREFIX: "serta.",
// 	supabase: {
// 		url: "http://127.0.0.1:54321",
// 		key: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6ImFub24iLCJleHAiOjE5ODM4MTI5OTZ9.CRXP1A7WOeoJeXxjNni43kdQwgnWNReilDMblYTn_I0",
// 		fileUrlPrefix: "http://127.0.0.1:54321/storage/v1/object/public/",
// 		imageRenderPrefix: "http://127.0.0.1:54321/storage/v1/render/image/public/",
// 		fileUrlResumablePrefix:
// 			"http://127.0.0.1:54321/storage/v1/upload/resumable/",
// 	},
// 	defaultTenant: "",
// 	mapboxApiKey:
// 		"pk.eyJ1IjoiY29saWJyeXgiLCJhIjoiY201dmFzcnZvMDU5cTJpc2V2ZWFob29ldyJ9.VCFaJzbEvTRsF5sx6HoeWg",
// 	tinymceApiKey: "",
// 	googleApiKey: "AIzaSyCUVtwJjN1XlK7HTDeVEue9DrJXyHI2EBQ",
// 	emailRedirectUrl: "http://localhost:4200",
// 	facebook: {
// 		appId: "949179747255578",
// 		configId: "534697479428922",
// 		apiVersion: "v20.0",
// 	},
// };
